import type { Maybe } from '../types/graphql';

interface GetInitialsProps {
  firstName?: Maybe<string> | undefined;
  fianceFirstName?: Maybe<string> | undefined;
}

export function getInitials({
  firstName,
  fianceFirstName,
}: GetInitialsProps): string | null {
  if (!firstName || !fianceFirstName) {
    return null;
  }

  const initial = firstName.charAt(0).toUpperCase();

  const fianceInitial = fianceFirstName.charAt(0).toUpperCase();

  return `${initial}&${fianceInitial}`;
}
